import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/tresh.svg';
import Button from 'components/Button/Button';
import IconButton from 'components/IconButton/IconButton';
import RoleIcon from 'components/RoleIcon/RoleIcon';
import Table from 'components/Table/Table';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableRow from 'components/Table/TableRow';
import { TASK_HEAD_ASSIGNED_USERS_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';
import { formatTextTitle } from 'utils/formatText';

import type IAssignedUsersTable from '../interfaces/IAssignedUsersTable';

import styles from '../sass/MaterialityAssessmentInitial.module.scss';

function AssignedUsersTable({
  usersInfo,
  onOpenJobPositionModal,
  onDeleteUser,
  btnTitle,
  isViewOnly = false,
}: IAssignedUsersTable) {
  const { t } = useTranslation();
  return (
    <Table className={styles.table}>
      <TableHead className={styles.header}>
        {TASK_HEAD_ASSIGNED_USERS_CELLS.map(({
          id, label,
        }) => (
          <TableCell
            head
            className={`${styles.tableCellHeader} ${id === 'action' ? styles.actionHeaderCell : ''}`}
            key={id}
          >
            <div>
              <span>{t(label)}</span>
            </div>
          </TableCell>
        ))}
      </TableHead>
      <TableBody className={styles.body}>
        {usersInfo?.map((user) => (
          <TableRow key={[user.value, user.label].join('_')}>
            <TableCell className={styles.tableCell}>
              <div>
                <span className={styles.name}>{user?.label}</span>
                <span className={styles.email}>{user?.email}</span>
              </div>
            </TableCell>
            <TableCell className={styles.tableCell}>
              <div className={styles.role}>
                <RoleIcon role={user.role} />
                <span>{user?.role ? formatTextTitle(user?.role) : '-'}</span>
              </div>
            </TableCell>
            <TableCell className={styles.tableCell}>
              <Button
                title={usersInfo.find((item) => item.value === user.value)?.position
                  || btnTitle}
                variant={BUTTON_VARIANT.ghost}
                className={styles.buttonAddJobPosition}
                startIcon={!usersInfo.find((item) => item.value === user.value)?.position
                  ? <PlusIcon /> : null}
                onClick={() => onOpenJobPositionModal(user.value || '')}
                disabled={isViewOnly}
              />
            </TableCell>
            <TableCell className={styles.actionCell}>
              <IconButton
                icon={<TrashIcon />}
                onClick={() => onDeleteUser(user.value || '')}
                className={styles.trashButton}
                disabled={isViewOnly}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default AssignedUsersTable;
